import Vue from 'vue';
import { Input, Menu, Modal, message, Popover } from 'ant-design-vue';

Vue.use(Input);
Vue.use(Menu);
Vue.use(Modal);
Vue.use(Popover);
Vue.prototype.$message = message;
